import { Component, Input } from '@angular/core';
import {  NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { AddonsTriggerVersionProPage } from '../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { DishCreateNutritionPage } from '../../dish-create/dish-create-nutrition/dish-create-nutrition';

/**
 * Generated class for the DishViewAllergensPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-dish-view-nutrition',
    templateUrl: 'dish-view-nutrition.html',
})
export class DishViewNutritionPage {
    @Input() dish: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public globals: Globals) {
    }

    edit() {
        if (this.globals.checkLimitsByLicense('dishes', 'nutrition')) {//version pro abierto
            this.navCtrl.push(DishCreateNutritionPage, {
                update: true,
                dish_uid: this.dish.UID,
                dish_name: this.globals.nameLangSelectDish(this.dish),
                dish: this.dish
            })
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }

}



// WEBPACK FOOTER //
// ./src/pages/dish/dish-view/dish-view-nutrition/dish-view-nutrition.ts